import React from "react";
import Select from "react-select";
import _ from "lodash";

const SearchableSelect = (props) => {
	const options = props.valueDataMap.map((tuple) => ({ value: tuple[0], label: tuple[1] }));
	const isSearchable = _.isNil(props.isSearchable) ? true : props.isSearchable;

	return (
		<Select
			className={props.className}
			options={options}
			defaultValue={options.find((item) => item.value === props.value)}
			onChange={props.onChange}
			name={props.placeholder}
			placeholder={props.placeholder}
			isClearable={props.isClearable}
			isSearchable={isSearchable}
			menuPosition="fixed"
			menuPlacement="auto"
			minMenuHeight={300}
		/>
	);
};

export default SearchableSelect;
